// shepherdTour.js
import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';

export const createTour = () => {
  const tour = new Shepherd.Tour({
    defaultStepOptions: {
      cancelIcon: { enabled: true },
      scrollTo: { behavior: 'smooth', block: 'center' },
      classes: 'shepherd-theme-arrows',
    },
    useModalOverlay: true,
  });

  if (document.querySelector('.take-our-assessment')) {
    tour.addStep({
      id: 'take-our-assessment',
      text: 'Take our assessment.',
      attachTo: { element: '.take-our-assessment', on: 'right' },
      buttons: [
        {
          text: 'Next',
          action: tour.next,
        },
      ],
    });
  }

  if (document.querySelector('.education-learn-more')) {
    tour.addStep({
      id: 'education-learn-more',
      text: 'This is education learn more.',
      attachTo: { element: '.education-learn-more', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          action: tour.back,
        },
        {
          text: 'Done',
          action: tour.complete,
        },
      ],
    });
  }

  return tour;
};
